<template>
	<div id="daibanList">
		<van-sticky>
			<van-nav-bar
				:title="title + '(' + unfinishedDataList.length + ')'"
				left-text="返回"
				left-arrow
				@click-left="onClickLeft"
			/>
		</van-sticky>
		<van-pull-refresh
			v-model="isLoading"
			success-text="刷新成功"
			@refresh="onRefresh"
			:disabled="showDrop"
		>
            <van-sticky offset-top="1.07rem">
                <van-search v-model="dropdownInput" @focus="hideTabs" @input="fuzzyQuery" placeholder="请输入任务名称" />
            </van-sticky>
                <div class="wrapper" v-if="showDrop" @click="showTabs">
                    <van-list
                        class="block"
                        v-model="loading1"
                        :finished="finished"
                        finished-text=""
                        @load="onLoad"
                    >
                        <van-cell v-for="(item,index) in inputTable" :key="index" :title="item.taskName" 
                        @click.stop="dropClick(item.taskCode, item.taskName)" />
                    </van-list>
                </div>
			<van-list
				v-model="loading1"
				:finished="finished"
				finished-text=""
				@load="onLoad"
			>
				<div v-for="(item, i) in unfinishedDataList" :key="i" @click="toList(item)" style="border: 1px solid #f1f1f1">
                    <span style="font-size: 0.33333rem;">{{item.stationName}}</span>
					<div class="daiban">
						<span class="blue-bg blue yuandian"></span>
						<div v-if="item.isNew" class="aline">
							{{ item.TaskName }}
						</div>
						<div v-else class="aline wutu">{{ item.TaskName }}</div>
						<!-- <van-icon
							v-if="item.isNew"
							class="iconfont tubiao"
							class-prefix="icon"
							name="new"
							color="#eb6460"
							style="margin-top: -0.5rem"
						/> -->
						<span class="date">{{ item.priceDate }}</span>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
import { getTaskGrid, getTaskNameList } from '@/api/baseMsg'
import { loading } from '../../common/loading'
export default {
	name: 'daibanList',
	data() {
		return {
			title: '待办列表',
			loading1: false,
            isLoading:false,
			finished: false,
			btnFlag: false,
			unfinishedDataList: [], //待办列表
			// 2022-01-17新增
            dropdownTitle: "",//下拉展示标题
            dropdownInput: "",//搜索筛选框
            inputTable: [],//新数组作为筛选存储数组
			showDrop: false,//展示drop标记
			tableList: [],//原数组
		}
	},
	created() {
		this.getCjpl();
		this.getTaskGrid();
	},
	mounted() {
		window.addEventListener('scroll', this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	methods: {
		//houcc 2021.04.01 首页代办列表
		getTaskGrid(code) {
			getTaskGrid({
                taskCode:code,
            }).then((res) => {
				this.unfinishedDataList = res
				loading(false);
			})
		},
        //type为0的时候为价格采集页面 type 为1时为价格审核页面
        toList(item) {//跳转 
            //跳转  价格采集页面
            var shispflag; //xianspflag 1蓝2绿3灰
            if (item.levelNum == 2 || item.levelNum == 3) {
                //省、市账户
                shispflag = item.shispflag;
            } else {
                //区县用户
                shispflag = item.xianspflag;
            }
            if(item.types=='0'){
               this.$router.push({
                path: '/jiagecaijiNew/jiagecaijiNew',
                query: {
                    code: item.tempCode,
                    taskCode: item.taskCode,
                    exeno: item.exeno,
                    taskId:item.taskID,
                    stateId:item.stateId,
                    shengspflag:item.shengspflag,//省审核
                    shispflag:item.shispflag,//市审核
                    dlrflag:item.dlrflag,//待录入
                    dsbflag:item.dsbflag,//待上报
                    ythflag:item.ythflag,//已退回
                    active2: 0,
                    levelNum:item.levelNum,
                    priceDate:item.priceDate,
                    lateReportTime:item.lateReportTime,
                }
            });
            }else if(item.types=='1'){
                this.$router.push({
                    path: '/jiageshenheListNew/jiageshenheListNew',
                    query: {
                        code: item.tempCode,
                        taskCode: item.taskCode,
                        exeno: item.exeno,
                        ExeNo: item.ExeNo,
                        taskId: item.taskID,
                        shispflag: shispflag,
                        shengspflag: item.shengspflag,
                        ythflag: item.ythflag,
                        levelNum: item.levelNum,
                        active2: this.active2,
                        priceDate: item.priceDate,
                        lateReportTime: item.lateReportTime,
                        stateId: item.stateId,
                    }
                });
            }
        },
		// 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
		scrollToTop() {
			const that = this
			let scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop
			that.scrollTop = scrollTop
			that.btnFlag = that.scrollTop > 130
			// that.isBarNav = that.scrollTop > 10;
		},
		//置顶图标
		backTop() {
			const that = this
			let timer = setInterval(() => {
				let ispeed = Math.floor(-that.scrollTop / 5)
				document.documentElement.scrollTop = document.body.scrollTop =
					that.scrollTop + ispeed
				if (that.scrollTop === 0) {
					clearInterval(timer)
				}
			}, 16)
		},
		init() {
			// 初始化待定
		},
		onClickLeft() {
			//返回首页
			this.$router.push({
				path: '/',
			})
		},
		onLoad() {
			//tabcard加载函数
			// 异步更新数据
			// setTimeout 仅做示例，真实场景中一般为 ajax 请求
			setTimeout(() => {
				for (let i = 0; i < 10; i++) {
					// this.acceptDataList.push(this.cardList.length + 1);
				}
				// 加载状态结束
				this.loading1 = false
				this.finished = true
			}, 1000)
		},
		onRefresh() {
			//下拉刷新函数
			setTimeout(() => {
				this.isLoading = false
				this.init()
			}, 300)
		},
		fuzzyQuery(keyWord) {//搜索筛选方法
            if(keyWord.length==0) {
                this.inputTable = this.tableList;
                return
            }
            let arr = [];
            for(let i = 0;i < this.tableList.length;i++) {
                if(this.tableList[i].taskName.indexOf(keyWord) >= 0) {
                    arr.push(this.tableList[i]);
                }
            }
            this.inputTable = arr;
        },
        dropClick(code, name) {
            //选择下拉列表点击事件
            this.dropdownInput = name;
            this.showDrop = !this.showDrop;
            // this.$refs.drop.toggle();
            this.getTaskGrid(code);
        },
		hideTabs() {//隐藏展示滚动tabs
			this.fuzzyQuery(this.dropdownInput);
            this.showDrop = true;
        },
        showTabs() {//展示滚动tabs
            this.showDrop = false;
		},
		getCjpl() {
            getTaskNameList({taskCode: "",taskName: "",ordercol: ""}).then(res => {
                this.tableList=res;
                this.inputTable = res;
            })
        },
	},
}
</script>
<style lang="scss" scoped>
/deep/.van-nav-bar__text:active {
    background-color: transparent;
}
.dropdown2 {
    /deep/.van-dropdown-menu__bar {
        width: 100vw!important;
        .van-dropdown-menu__title::after {
            right: 0px;
        }
    }
}

/deep/.van-overlay {
        top: 2.35rem;
        z-index: 150;
    }
    .wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 2.35rem;
        left: 0;
        z-index: 1000;
        background-color: rgba(0,0,0,.7);
    }
    
    .block {
        position: relative;
        width: 100%;
        max-height: 50vh;
        background-color: #fff;
        color: #000;
        overflow-x: hidden;
        overflow-y:scroll;
        -webkit-overflow-scrolling:touch;
    }

.daibansousuo {
	width: 100%;
	height: 44px;
	line-height: 44px;
	background-color: #4494f3;
	font-size: px2rem(36);
	font-weight: bold;
	color: #fff;
	.inner {
		margin-left: px2rem(25);
		.white-box {
			display: inline-block;
			width: 0.06rem;
			height: 0.26rem;
			margin-right: 0.09rem;
			background-color: #fff;
		}
	}
	.shijian {
		display: inline-block;
		width: px2rem(260);
		height: px2rem(60);
		line-height: px2rem(60);
		text-align: center;
		border: 1px solid #fff;
		border-radius: 999px;
		font-size: px2rem(30);
		font-weight: normal;
		margin-left: px2rem(10);
		margin-right: px2rem(10);
		background-color: #65a7f4;
	}
	.sousuobtn {
		display: inline-block;
		width: px2rem(130);
		height: px2rem(62);
		line-height: px2rem(62);
		text-align: center;
		border: 1px solid #fff;
		border-radius: 999px;
		font-size: px2rem(36);
		font-weight: normal;
		margin-left: px2rem(40);
		margin-right: px2rem(10);
		background-color: #fff;
		color: #4494f3;
	}
}
.daiban {
	// padding-top: 0.40rem;
    padding-top: 0.01rem;
	height: 0.5rem;
	span {
		color: #6e6e6e;
		font-size: px2rem(36);
	}
	.aline {
		position: absolute;
		left: 0.5rem;
		color: #6e6e6e;
		font-size: px2rem(36);
		width: 5.7rem;
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.wutu {
		width: 7rem;
	}
	.yuandian {
		position: absolute;
		margin-top: 0.12rem;
		left: 0.2rem;
		display: inline-block;
		border: 3px solid #4e98f3;
		border-radius: 45%;
	}
	.icon {
		font-size: px2rem(95);
	}
	.icon-content {
		margin-top: px2rem(36);
		color: #6e6e6e;
	}
	.tubiao {
		position: absolute;
		left: 5.6rem;
	}
	.date {
		position: absolute;
		right: 0.3rem;
	}
}
</style>
